<div class="flex flex-col w-full">
  <div
    class="flex items-center justify-between pr-2 py-2 pl-3 self-stretch border border-neutrals-300 bg-neutrals-100 w-full gap-3"
    [ngClass]="{
      'rounded-t-[4px]': isOpen,
      'rounded-[4px]': !isOpen,
    }"
    (click)="toggleAccordion()"
  >
    <ui-paragraph
      class="whitespace-nowrap"
      type="p10"
      mobile-type="p10"
      text-color="neutrals-700"
      font-weight="medium"
      [content]="title"
    />
    <div class="flex gap-2">
      <ui-paragraph
        class="text-end leading-tight"
        type="p10"
        mobile-type="p10"
        text-color="neutrals-900"
        font-weight="semibold"
        [content]="productName"
      />
      <ui-icon
        [attr.name]="isOpen ? 'chevron-up' : 'chevron-down'"
        size="16"
        mobile-size="16"
        fill="primary-500"
      ></ui-icon>
    </div>
  </div>
  <div
    *ngIf="isOpen"
    class="flex items-center justify-between gap-3 w-full pr-2 py-2 pl-3 border border-t-0 border-neutrals-300 bg-white rounded-b-[4px] transition-all duration-300"
  >
    <ui-paragraph
      class="whitespace-nowrap"
      type="p10"
      mobile-type="p10"
      text-color="neutrals-700"
      font-weight="medium"
      content="Cantidad"
    />
    <ui-paragraph
      class="text-end leading-tight"
      type="p10"
      mobile-type="p10"
      text-color="neutrals-900"
      font-weight="semibold"
      [content]="quantityText"
    />
  </div>
</div>
